import { Request } from '@/classes/Request.ts'

export interface EnrollmentDashboardTokenResponse {
  success: boolean
  cloud_token?: string
  family_user_id?: number
  failure_reason?: string
}

/**
 * Mint a session token for the invitation's family user so the enrollment
 * summary page can hand off into the parent dashboard as that family. Backed by
 * the public, token-authenticated enrollment endpoint, which only issues a token
 * once the invitation is completed. The returned cloud_token is redeemed by the
 * global router guard (?cloud_token= -> /ajax/family/exchange-token).
 */
export const enrollmentDashboardToken = async (
  token: string
): Promise<EnrollmentDashboardTokenResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/dashboard-token`
  )
  return response.data
}
